var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNpInviteUser = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.775,
    height: 14.513,
    viewBox: "0 0 17.775 14.513",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_invite-user_4143618_000000",
    transform: "translate(-6.339 -9.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5736",
    "data-name": "Path 5736",
    d: "M28.13,15.635a3.13,3.13,0,1,1,3.13-3.13A3.121,3.121,0,0,1,28.13,15.635Zm0-4.553A1.423,1.423,0,1,0,29.553,12.5,1.409,1.409,0,0,0,28.13,11.082Z",
    transform: "translate(-15.263)",
    fill: "#908b96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5737",
    "data-name": "Path 5737",
    d: "M18.018,56.091H7.717a1.378,1.378,0,0,1-1.024-.455,1.321,1.321,0,0,1-.341-1.053,6.589,6.589,0,0,1,13.09,0,1.393,1.393,0,0,1-.341,1.053,1.608,1.608,0,0,1-1.081.455ZM17.705,54.668Zm-9.277-.285h8.879a.285.285,0,0,0,.285-.285v-.085a4.878,4.878,0,0,0-9.391,0,.293.293,0,0,0,.2.341c-.028.028,0,.028.028.028Z",
    transform: "translate(0 -32.203)",
    fill: "#908b96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5738",
    "data-name": "Path 5738",
    d: "M68.191,30.971a.838.838,0,0,1-.854.854H66.2v1.138a.854.854,0,1,1-1.707,0V31.824H63.354a.854.854,0,0,1,0-1.707h1.138V28.979a.854.854,0,1,1,1.707,0v1.138h1.138A.838.838,0,0,1,68.191,30.971Z",
    transform: "translate(-44.078 -17.272)",
    fill: "#908b96"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNpInviteUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/np_invite-user.c3f8f8fb.svg";
export { ForwardRef as ReactComponent };